import HStack from '@jimmyboys/liita-ui/dist/components/HStack'
import Icon from '@jimmyboys/liita-ui/dist/components/Icon'
import Portal from '@jimmyboys/liita-ui/dist/components/Portal'
import VStack from '@jimmyboys/liita-ui/dist/components/VStack'
import styles from './AppointmentHelpTooltip.module.sass'
import { forwardRef } from 'react'
import { useGlobal } from '@jimmyboys/liita-ui/dist/components/GlobalContext'

const AppointmentHelpTooltip = forwardRef((props, ref) => {
	const {
		showHelp,
		removeBackdrop,
		toggleHelp,
		toggleBackdrop,
		...attributes
	} = props
	const { i18n } = useGlobal()

	const mountPoint = document.getElementById('help-dialog-container')

	const buttonPosition = ref.current?.getBoundingClientRect()

	return (
		<Portal id={'help-dialog-container'} ref={mountPoint}>
			{removeBackdrop && (
				<span
					className={styles['helper-backdrop']}
					onClick={(e) => {
						e.preventDefault()
						e.stopPropagation()
					}}
				/>
			)}
			{showHelp ? (
				<HStack
					{...attributes}
					className={styles['tooltip-root']}
					style={{
						'--left-pos': `${buttonPosition?.left}px`,
						'--top-pos': `${
							buttonPosition?.top + window.pageYOffset
						}px`,
						'--button-height': `${buttonPosition?.height}px`,
					}}
				>
					<VStack className={styles['tooltip-help-container']}>
						<HStack className={styles['tooltip-help-content']}>
							<VStack
								className={styles['tooltip-help-left-content']}
							>
								<h4>{i18n`Appointment data`}</h4>
								<VStack>
									<h5>{i18n`Medical Specialty`}</h5>
									<small>{i18n`Medic`}</small>
								</VStack>
								<HStack
									className={styles['tooltip-help-previous']}
								>
									<Icon
										className={
											styles['subdirectory-arrow-icon']
										}
										name='subdirectory-arrow'
										width='20px'
										height='20px'
									></Icon>
									<VStack>
										<small>
											{i18n`Previous appointment`}
										</small>
										<small>{i18n`#appointmentid`}</small>
									</VStack>
								</HStack>
								<h5>{i18n`Appointment date and time`}</h5>
								<VStack
									className={styles['tooltip-help-transport']}
								>
									<h5>{i18n`serviceProviderId`}</h5>
									<small>{i18n`Used transport`}</small>
								</VStack>
							</VStack>
							<VStack
								className={styles['tooltip-help-right-content']}
							>
								<h4>{i18n`Medical Observation`}</h4>
								<small>
									{i18n`Summary of the assessment carried out by the medic within the scope of the appointment`}
									.
								</small>
								<VStack>
									<h5>{i18n`ITA 100%`}</h5>
									<small>{i18n`Appointment disability`}</small>
								</VStack>
							</VStack>
						</HStack>
						<div
							className={styles['tooltip-help-button-container']}
						>
							<button
								className={styles['tooltip-help-close-button']}
								onClick={() => {
									toggleHelp()
									toggleBackdrop()
								}}
							>
								<strong>{i18n`Close`}</strong>
							</button>
						</div>
					</VStack>
					<div className={styles['tooltip-pointer']} />
				</HStack>
			) : null}
		</Portal>
	)
})

export default AppointmentHelpTooltip
